// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"f4eb72eb","587":"7a239855"}[chunkId] + ".chunk.css";
};